import { render, staticRenderFns } from "./PreferenceSettings.vue?vue&type=template&id=57fbc794&scoped=true&"
import script from "./PreferenceSettings.vue?vue&type=script&lang=js&"
export * from "./PreferenceSettings.vue?vue&type=script&lang=js&"
import style0 from "./PreferenceSettings.vue?vue&type=style&index=0&id=57fbc794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fbc794",
  null
  
)

export default component.exports